import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    DeviceSearchResults,
    IDeviceSearchResult,
} from "../../types/singleApplication/searchLctTypes"

export const searchLctMapper = {
    /** Validates response is of type IDeviceSearchResult[] */
    map: (response: unknown): IDeviceSearchResult[] =>
        tsIoValidate<IDeviceSearchResult[]>(
            DeviceSearchResults,
            response,
            "searchLctMapper"
        ),
}
